import { ModalWindow } from '@cian/ui-kit';
import { useEventCallback } from '@cian/react-utils';

import { OffersHistoryContentLoadable } from './OffersHistoryContentLoadable';

import { FC, useEffect, useCallback, useState } from 'react';
import { EntryBanner } from '../../components/Mobile';
import { useOffersHistoryContext } from '../../context';

interface IOffersHistoryContainerProps {
  bannerText: string;
  onBannerClick: VoidFunction;
}

export const OffersHistoryContainer: FC<IOffersHistoryContainerProps> = ({ bannerText, onBannerClick }) => {
  const [isOpen, setOpen] = useState(false);

  const onHandleClose = useEventCallback(() => {
    setOpen(false);
  });

  const onHandleOpen = useEventCallback(() => {
    setOpen(true);
    onBannerClick();
  });

  const {
    data: {
      listing: { data },
    },
    getOffersHistory,
    changeFilters,
    resetAllFilters,
  } = useOffersHistoryContext();

  useEffect(() => {
    if (isOpen && !data) {
      getOffersHistory(false);
    }

    return () => {
      changeFilters(false);
    };
  }, [isOpen, data, getOffersHistory, changeFilters]);

  const onModalCloseHandler = useCallback(() => {
    /** При закрытии модалки, фильтры, которые накликал юзер, и данные листинга сбросятся */
    resetAllFilters();
    onHandleClose();
  }, [onHandleClose, resetAllFilters]);

  return (
    <>
      <EntryBanner text={bannerText} onClick={onHandleOpen} />
      <ModalWindow
        open={isOpen}
        onClose={onModalCloseHandler}
        title="История объявлений"
        content={<OffersHistoryContentLoadable />}
      />
    </>
  );
};
